import { type FC } from 'react';
import { Link } from 'react-router-dom';

const linkClass = 'inline-flex items-center min-h-[44px] px-1 hover:text-text-primary underline-offset-2 hover:underline';

/**
 * AppFooter - the one-line footer for signed-in pages. Public pages keep the full Footer.
 */
export const AppFooter: FC = () => (
  <footer className="border-t border-border-subtle bg-bg-secondary mt-auto">
    <div className="mx-auto max-w-[var(--layout-standard)] px-4 sm:px-6 lg:px-8 flex flex-wrap items-center justify-center gap-x-3 text-xs text-text-muted">
      <span>&copy; {new Date().getFullYear()} OzDyne Ltd</span>
      <span aria-hidden="true">&middot;</span>
      <Link to="/privacy-policy" className={linkClass}>Privacy</Link>
      <span aria-hidden="true">&middot;</span>
      <Link to="/terms-and-conditions" className={linkClass}>Terms</Link>
      <span aria-hidden="true">&middot;</span>
      <a href="mailto:grimdarkcompanion@ozdyne.com" className={linkClass}>Feedback</a>
    </div>
  </footer>
);
